import '.ao{flex-shrink:0;}.ssr-plugin'
import '.aa{padding:1rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.b0{height:100%;}.ssr-plugin'
import '.ca{border:none;}.ssr-plugin'
import '.ce{background-color:transparent;}.ssr-plugin'
import '.cf{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.af{align-items:stretch;}.ssr-plugin'
import '.bd{position:sticky;}.ssr-plugin'
import '.cg{top:4rem;}.ssr-plugin'
import '.ch{z-index:7;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.ci{padding-bottom:1rem;}.ssr-plugin'
import '.cj{margin-bottom:1rem;}.ssr-plugin'
import '.ck{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.f{position:fixed;}.ssr-plugin'
import '.be{top:0px;}.ssr-plugin'
import '.bj{left:0px;}.ssr-plugin'
import '.bk{right:0px;}.ssr-plugin'
import '.bl{bottom:0px;}.ssr-plugin'
import '.cl{z-index:9999;}.ssr-plugin'
import '.cm{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.bx{justify-content:flex-end;}.ssr-plugin'
import '.b1{flex:1;}.ssr-plugin'
import '.bv{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="ao aa l b0 ca ce cf"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b af"
    >
      <div className="bd cg ch t ci cj ck a"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="f be bj bk bl cl t cm a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="aa a bx ck"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="b1 bv">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
